<template>
  <!-- <span v-if="[62, 2569, 2571, 2548].includes(parseInt(this.$store.getters.getUserGroupId))">Spätestens KW 51</span> -->
  <span v-if="time === 0 || time === 1">sofort versandfertig</span>
  <span v-else-if="time > 1 && time <= 14">in {{ time }} Tagen versandfertig</span>
  <span v-else>am {{ getDeliveryReadyDateString(time) }} versandfertig</span>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'DeliveryTimeInner',
  props: {
    time: {
      type: Number,
      default: 0,
    },
  },
  mixins: [logicMixin],
};
</script>
